<template>
  <div class="webSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Input
          v-model="webName"
          :placeholder="$t('configuration_management.schedules.queryByName')"
        />
      </Col>
      <Col span="6">
        <DatePicker
          :open="openPicker"
          v-model="agentDate"
          type="datetimerange"
          :placeholder="$t('RAM.common.PleaseSelectTimeRange')"
          :transfer="true"
          :options="timeOptions"
          @on-change="handleChange"
          @on-open-change="openChange"
          @on-ok="handleOk"
          style="width: 100%;"
          @on-clear="handleClear"
        ></DatePicker>
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['network:webMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
        <Button
          type="warning"
          :loading="modal_loading"
          @click="exportList"
          :disabled="isDisable"
          v-hasPermission="['network:webMonitor:export']"
          >{{ $t("common.export") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableWeb from "../web/TableWeb";
var tableWeb = TableWeb;
export default {
  name: "WebMonitorSearch",
  data() {
    return {
      isDisable: true,
      modal_loading: false,
      agentDate: "",
      webName: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      timeOptions: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        }
      },
      openPicker: null,
      webNameSearchID: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("webName", this.webName);
      tableWeb.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    openChange() {
      this.openPicker = true;
    },
    handleOk() {
      if (this.endDate - this.startDate < 30 * 24 * 60 * 60 * 1000) {
        this.openPicker = false;
        this.isDisable = false;
      } else {
        alert(this.$t("monitor.search.timeIntervalExceedMonth"));
        this.openPicker = true;
      }
    },
    // 时间验证
    handleChange(val) {
      if (val[0] == "" && val[1] == "") {
        this.startDate = 0;
        this.endDate = 0;
        this.openPicker = true;
      } else {
        this.startDate = new Date(val[0]).getTime();
        this.endDate = new Date(val[1]).getTime();
      }
    },
    handleClear() {
      this.isDisable = true;
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t("common.exporting")
      });

      // 下载Excel 文件
      this.$api.resourceAzureAppService
        .exportAzureAppServiceUseCondition({
          timeList: this.agentDate,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = this.$t("monitor.web.exportFileName");
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t("common.exportSuccess"));
        });
    }
  }
};
</script>
<style scoped>
.webSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/WebMonitorSearch.vue